import ViewActionTypes from './view.types';

export const setCurrentView = (newView, viewData) => ({
  type: ViewActionTypes.SET_CURRENT_VIEW,
  payload: {
    currentView: newView,
    viewData: !viewData ? {} : viewData
  }
});